<script>
import Vue from 'vue';
import { Dialog, Message, Select, Option, Checkbox } from 'element-ui';
import VueButton from '~/components/button/components/button';
import FormGroup from '~/components/form/components/form_group';
import Permissions from '~/services/permissions/vue_permissions';
import SkeletonLoader from '~/components/loader/components/skeleton_loader';
import AppendToBody from '~/mixins/append_to_body';

Vue.use(Permissions);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Checkbox);

export default {
    name: 'facebook-accounts-modal',

    mixins: [AppendToBody],

    components: {
        VueButton,
        FormGroup,
        SkeletonLoader
    },

    props: {
        shouldReload: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isSubmitting: false,
            isOpen: false,
            pages: [],
            selectedPages: [],
            initSelectedPages: [],
            user: {
                id: null,
                user_id: null,
                external_user_id: null,
                active: null,
                profile_img: null,
                user_name: null,
                description: null,
                url: null,
                is_valid: null
            },
            userSelected: false
        }
    },

    methods: {
        onOpen() {
            this.getFormData();
        },

        connect() {
            this.isSubmitting = true;

            $.ajax({
                url: '/integration/facebook-form',
                type: 'POST',
                data: {
                    facebook_page: this.getSelectedPagesObj(),
                    facebook_user_id: this.user.external_user_id,
                    user_account_active: this.userSelected
                },
                global: false
            })
            .done((data) => {
                this.isSubmitting = this.shouldReload;

                if (this.shouldReload) {
                    window.location.reload();
                } else {
                    this.$emit('connect', data);
                    this.isOpen = false;
                }
            })
        },

        getSelectedPagesObj() {
            return this.pages.filter(page => {
                return this.selectedPages.includes(page.page_id);
            });
        },

        getFormData() {
            $.ajax({
                url: '/integration/facebook-form-json',
                type: 'GET',
                global: false
            })
            .done((data) => {
                this.pages = data.pages;
                this.initSelectedPages = data.connected_pages;
                this.setSelectedPages(data.connected_pages);
                this.user = data.user;
                this.userSelected = data.user.active == '1';
            })
            .fail((xhr) => {
                Message({
                    type: 'error',
                    message: xhr.responseJSON.message
                });
            });
        },

        setSelectedPages(pages) {
            this.selectedPages = pages.map(page => {
                return page.user_api_gateway_external_id;
            });
        },

        onClose() {
            if (!this.selectedPages.length && !this.userSelected) {
                this.deleteConnection();
            }
        },

        deleteConnection() {
            $.ajax({
                url: '/integration/delete',
                type: 'GET',
                data: {
                    name: 'facebook',
                    external_user_id: this.user.external_user_id
                },
                global: false
            })
            .done(() => {
            });
        }
    }
}
</script>

<template>
    <el-dialog
        title="Facebook Accounts"
        size="tiny"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="isOpen"
        @open="onOpen"
        @close="onClose"
    >
        <p class="m-b-15 text-black">
            Which accounts would you like to connect?
        </p>

        <form-group label="Pages" v-if="pages.length">
            <el-select class="truncate--tags" v-model="selectedPages" size="small" multiple placeholder="Select Pages">
                <el-option
                    v-for="page in pages"
                    :key="page.page_id"
                    :label="page.name"
                    :value="page.page_id">
                </el-option>
            </el-select>
        </form-group>

        <div slot="footer" class="dialog-footer">
            <vue-button
                type="primary"
                @click="connect"
                :loading="isSubmitting"
                :disabled="! user.id || isSubmitting"
                loading-text="Connecting"
            >
                Update Connections
            </vue-button>
        </div>
    </el-dialog>
</template>
